import { Flex, Typography } from 'antd';
import { formatDistanceToNow } from 'date-fns';
import { NotificationExtended } from 'src/api/generated';
import { StyledButton } from './ViewImport.styled';
import { useTranslation } from 'react-i18next';
import { useAppNavigation } from 'src/routes';

interface ViewImportProps {
  item: NotificationExtended;
}

const ViewImport = (props: ViewImportProps) => {
  const { item } = props;
  const { t } = useTranslation();
  const { navigateTo } = useAppNavigation();

  const onClickHandler = () => {
    if (item.id) {
      navigateTo.peopleImportProcess({
        jobId: item.id,
        numberOfRows: item.totalRows ?? 0,
        fileName: item.title,
      });
    }
  };

  return (
    <Flex justify="space-between">
      <Typography.Text>{formatDistanceToNow(item.timestamp)}</Typography.Text>
      <StyledButton onClick={onClickHandler} type="link">{`${t('general.view')} ${t('general.import')}`}</StyledButton>
    </Flex>
  );
};

export default ViewImport;
